import { Flex, Spinner } from '@applyboard/crystal-ui';

import { useMediaQuery } from '~/hooks/useMediaQuery';
import { ErrorHandler } from '~/pages/ErrorPage';
import { DesktopLayout } from './DesktopLayout';
import { TabletLayout } from './TabletLayout';
import { MobileLayout } from './MobileLayout';
import { useGradeConversionCreatePageData } from '../hooks/useGradeConversionCreatePageData';
import { GradeConversionCreateLayoutProps } from './types';

export const GradeConversionCreateLayout = () => {
  const { isUltraWide, isWide, isNormal, isNarrow, isUltraNarrow, isMobile } = useMediaQuery();
  const data = useGradeConversionCreatePageData();

  if (data.isLoading) {
    return (
      <Flex p={5} gap={5} align="center" direction="column" role="progressbar">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (data.error || !data.gradeSchemas || !data.gradePointMappings || !data.educationLevels || !data.countries) {
    return (
      <ErrorHandler
        error={data.error ?? new Error('Failed to load grade conversion create data.')}
        customMessage="Failed to load grade conversion create data."
      />
    );
  }

  const layoutProps: GradeConversionCreateLayoutProps = {
    gradeSchemas: data.gradeSchemas,
    gradePointMappings: data.gradePointMappings,
    educationLevels: data.educationLevels,
    countries: data.countries,
  };

  if (isUltraWide || isWide) {
    return <DesktopLayout {...layoutProps} />;
  }

  if (isNormal || isNarrow || isUltraNarrow) {
    return <TabletLayout {...layoutProps} />;
  }

  if (isMobile) {
    return <MobileLayout {...layoutProps} />;
  }

  // should not reach here
  return <DesktopLayout {...layoutProps} />;
};
